import React, { useState } from 'react';

import { ReactComponent as ResumeIcon } from '../static/icons/Resume.svg';
import { ReactComponent as InterviewIcon } from '../static/icons/Interview.svg';
import { ReactComponent as OliIcon } from '../static/icons/Progress Report - Oli (Green).svg';

function LandingCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const items = [
    {
      type: 'image',
      src: '/landing_media/landingresume.jpg', // placeholder
      alt: 'Slide 1',
      caption: 'Our Resume Evaluator improves yours for job applications',
      Icon: ResumeIcon, // Resume icon
    },
    {
      type: 'video',
      src: '/landing_media/landingvid.mp4', // placeholder
      alt: 'Slide 2',
      caption: 'AI Insights guide you as you practice coding',
      Icon: OliIcon, // Oli icon
    },
    {
      type: 'image',
      src: '/landing_media/landinginterviewer.jpg', // placeholder
      alt: 'Slide 3',
      caption: 'Our Virtual Interviewer guides you to improve interview skills',
      Icon: InterviewIcon, // Interview icon
    },
  ];

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % items.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  const currentItem = items[currentIndex];

  return (
    <div style={{ textAlign: 'center', maxWidth: '800px', width: '100%' }}>
      {currentItem.type === 'image' ? (
        <img
          src={currentItem.src}
          alt={currentItem.alt}
          style={{ width: '100%', height: 'auto', marginBottom: '0.5rem' }}
        />
      ) : (
        <video controls style={{ width: '100%', marginBottom: '0.5rem' }}>
          <source src={currentItem.src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}

      <div
        style={{
          marginBottom: '1rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {items.map((_, index) => (
          <div
            key={index}
            onClick={() => setCurrentIndex(index)}
            style={{
              width: currentIndex === index ? '10px' : '8px',
              height: currentIndex === index ? '10px' : '8px',
              borderRadius: '50%',
              backgroundColor: '#ccc',
              margin: '0 4px',
              cursor: 'pointer',
            }}
          />
        ))}
      </div>

      <div
        style={{
          marginBottom: '1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <button
          onClick={handlePrev}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '0 8px',
          }}
        >
          <svg width="32" height="32" viewBox="0 0 24 24">
            <path fill="#FFF" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            margin: '0 8px',
          }}
        >
          <currentItem.Icon
            color="#E1E1E6"
            style={{
              width: '30px',
              height: '30px',
              marginRight: '8px',
            }}
          />
          <span
            style={{
              fontFamily: 'Quicksand, sans-serif',
              color: '#FFF',
              fontSize: '16px',
            }}
          >
            {currentItem.caption}
          </span>
        </div>

        <button
          onClick={handleNext}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '0 8px',
          }}
        >
          <svg width="32" height="32" viewBox="0 0 24 24">
            <path fill="#FFF" d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default LandingCarousel;